import { create } from 'zustand';

import type { SectionStatus, VehicleDetailsPositioningStore } from './VehicleDetailsPositionStore.types';

const getInitialSections = (sections: { id: string }[]): SectionStatus[] =>
	sections.map(({ id }) => ({ active: false, id, timeStamp: 0 }));

export const useVehicleDetailsPositioning = create<VehicleDetailsPositioningStore>((set) => ({
	active: null,
	initSections: (sections) => set({ sections: getInitialSections(sections) }),
	resetSections: (sections) => set({ sections: getInitialSections(sections) }),
	sections: [],
	setActive: (id: string) =>
		set((state) => {
			const now = Date.now();

			// Uncomment to measure time difference between sections
			// const previousSection = state.sections.find((section) => section.active);
			// calculateTimeDifferenceBetweenSections({ id, newTimeStamp: now, previousSection });

			const sections = state.sections.map((section) => {
				if (section.id === id) {
					return { ...section, active: true, timeStamp: now };
				}

				return { ...section, active: false };
			});
			const active = { active: true, id, timeStamp: now };
			return { active, sections };
		}),
}));

export const useGetActiveSection = (): VehicleDetailsPositioningStore['active'] =>
	useVehicleDetailsPositioning((store) => store.active);
export const useResetSections = (): VehicleDetailsPositioningStore['resetSections'] =>
	useVehicleDetailsPositioning((store) => store.resetSections);
export const useSetActiveSection = (): VehicleDetailsPositioningStore['setActive'] =>
	useVehicleDetailsPositioning((store) => store.setActive);
export const useGetSections = (): VehicleDetailsPositioningStore['sections'] =>
	useVehicleDetailsPositioning((store) => store.sections);
export const useInitSections = (): VehicleDetailsPositioningStore['initSections'] =>
	useVehicleDetailsPositioning((store) => store.initSections);
